import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder } from "@/types";

export function useDeleteRemoveJobStakeholder() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stakeholderId }: { stakeholderId: number }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/stakeholders/${stakeholderId.toString()}`;
      const res = await guacHttpClient.delete<
        Stakeholder,
        HttpResponse<Stakeholder>
      >(path);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        ["job-stakeholders", currentCompanyId, currentJobId],
        (cachedData?: Stakeholder[]) => {
          if (!cachedData) return cachedData;
          return cachedData.filter((s) => s.id !== variables.stakeholderId);
        },
      );
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["job-intake", currentCompanyId, currentJobId],
      });
    },
  });
}
